/*=========================================================================================
  File Name: index.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import jwt from "jsonwebtoken";
import store from "../store/store";
import VueCookie from "vue-cookie";
import { isMobile } from "mobile-device-detect";

import routerProject from "./router-project";
import routerMain from "./router-main";
import routerBoards from "./boards";
import routerBs from "./bs";
import routerFields from "./fields";
import routerFilelibrary from "./filelibrary";

Vue.use(Router);

/**
 * 권한 체크
 * @returns {function(*, *, *): (*)}
 */
async function requireAuth(to, from, next) {
  let userToken = store.state.auth.userToken;
  let isAuthenticated = false;

  if (!userToken || userToken === "") {
    userToken = VueCookie.get("token");
  }
  if (userToken) {
    try {
      // jwt.decode 로 만료 기간 체크 (exp)
      const decToken = jwt.decode(userToken);
      const currentTime = new Date().getTime() / 1000;

      if (currentTime < decToken.exp) {
        isAuthenticated = true;
      }

      // eslint-disable-next-line no-empty
    } catch (err) {}
  } else {
    VueCookie.delete("token"); // 현재 토큰 제거
    VueCookie.delete("current_id"); // 현재 보고있는 게시물 넘버
  }

  // 게스트도 볼 수 있는가? 체크
  // api 제작필요.

  // 게스트는 볼 수 없는 경우
  // 내가 보려고하는 페이지에 권한이 있는가 체크
  // 나의 권한 가져오기 api 제작필요

  if (!isAuthenticated) {
    await store.dispatch("REFRESH_TOKEN").catch((err) => {
      VueCookie.set("LOGIN_TO_FULLPATH", to.fullPath); // 로그인 후 이동할 페이지
      VueCookie.delete("token"); // 현재 토큰 제거
      VueCookie.delete("current_id"); // 현재 보고있는 게시물 넘버
      return next("/login");
    });
  }
  await store.dispatch("USER_INFO");
}

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  routes: [
    ...routerProject,
    ...routerMain,
    ...routerBoards,
    ...routerBs,
    ...routerFields,
    ...routerFilelibrary,
    {
      path: "",
      component: () => import("@/layouts/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES - WEB
        // =============================================================================
        // login
        {
          path: "/login",
          name: "page-login",
          component: () => import("@/views/pages/login/Login.vue"),
          meta: {
            deviceRequired: true,
          },
        },
        {
          path: "/reset-password",
          name: "page-reset-password",
          component: () => import("@/views/pages/login/ResetPassword.vue"),
        },
        {
          path: "/forgot-password",
          name: "page-forgot-password",
          component: () => import("@/views/pages/login/ForgotPassword.vue"),
        },
        {
          path: "/register",
          name: "page-register",
          component: () => import("@/views/pages/register/Register.vue"),
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
        },
      ],
    },

    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404",
    },
  ],
});

router.beforeEach((to, from, next) => {
  const checkAuthRequired = to.matched.some(function (routeInfo) {
    return routeInfo.meta.authRequired;
  });
  const checkMobile = to.matched.some(function (routeInfo) {
    return routeInfo.meta.deviceRequired;
  });

  // 로그인 여부
  if (checkAuthRequired) {
    requireAuth(to, from, next);
  }

  // 모바일 여부
  // if (checkMobile) {
  //   requireMobile(to, from, next)
  // }

  const listSearchFiledName = store.state.menu.listSearchFiledName;
  if (listSearchFiledName && to.params.boardId === from.params.boardId && to.params.proj_id === from.params.proj_id && to.name === "list|tab" && to.params.boardId === `${listSearchFiledName.boardId}`) {
    store.commit("menu/CLEAR_LISTSEARCHFILEDNAME");
    next({
      path: to.path,
      query: {
        ...to.query,
        cName: listSearchFiledName.name,
      },
      replace: true,
    });
  } else {
    store.commit("menu/CLEAR_LISTSEARCHFILEDNAME");
    return next();
  }
});

const BASE_TITLE = document.title;

router.afterEach((to) => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }

  if (to.meta && to.meta.pageTitle) {
    document.title = `${to.meta.pageTitle} | ${BASE_TITLE}`;
  } else {
    document.title = BASE_TITLE;
  }
});

// window resize 체크
const updateSizes = (obj = {}) => {
  obj.width = window.innerWidth;
  obj.height = window.innerHeight;
  obj.screens = ["sm", "md", "lg", "xl", "xxl"];
  if (obj.width >= 1440) obj.screen = "xxl";
  else if (obj.width >= 1200) obj.screen = "xl";
  else if (obj.width >= 992) obj.screen = "lg";
  else if (obj.width >= 768) obj.screen = "md";
  else if (obj.width >= 576) obj.screen = "sm";
  else obj.screen = "xs";
  // mobile 체크
  obj.isMobile = obj.width < 1200;
  return obj;
};
Object.defineProperty(Vue.prototype, "$viewport", {
  value: Vue.observable(updateSizes()),
});
window.addEventListener("resize", (e) => {
  updateSizes(Vue.prototype.$viewport);
});

export default router;
